module.exports = require("core-js/library/fn/array/find");


//////////////////
// WEBPACK FOOTER
// ../~/@babel/runtime-corejs2/core-js/array/find.js
// module id = 110
// module chunks = 1